export const getPercentValue = (dividend: number, divisor: number): number => Math.round(dividend / divisor * 100);
// cross-browser solution
export const getWindowWidth = () =>
  (window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth);
